import { i18n as I18n } from '../utils/i18n';

// A function rather than a constant: translations must resolve during render,
// not at import time, when i18next has not been initialised yet.
export const getWeekdays = () => [
  I18n.t('week_days.monday'),
  I18n.t('week_days.tuesday'),
  I18n.t('week_days.wednesday'),
  I18n.t('week_days.thursday'),
  I18n.t('week_days.friday'),
  I18n.t('week_days.saturday'),
  I18n.t('week_days.sunday'),
];
